import * as _ from 'lodash';

export function getObjectValue(object: any, fieldPath: string) {
    return _.get(object, fieldPath);
}
export function addZero(n) {
    return n < 10 ? '0' + n : n
}

export const recursive = (node, call: (x) => void ) => {
    call(node);
    if (node.children.length > 0) {
        node.children.map(t => recursive(t, call));
    }
};
